import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AdminUsers";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import toast from "react-hot-toast";
import BetHistoryModal from "./BetHistoryModal";


const Settlement = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [settlements, setSettlements] = useState([]);
  const [filteredSettlements, setFilteredSettlements] = useState([]);
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [history, setHistory] = useState([]); // Store navigation history
  const [betModalVisible, setBetModalVisible] = useState(false);
  const [selectedPhone, setSelectedPhone] = useState("");
  const [userBetData, setUserBetData] = useState([]);
  const [userCainoBetData, setUserCasinoBetData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const FetchUserData = async (specificCode = null) => {
    try {
      setLoading(true);
      const auth = localStorage.getItem("admin");

      const response = await axios.get(`${base_url}/api/admin/getMySettleHistory`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`
        },
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
          code: specificCode || undefined
        }
      });

    //   console.log("Response is all settlemet ", response)

      const data = response.data.data || [];

      setSettlements(data);
      setFilteredSettlements(data);
      setTotalProfit(response.data.totalProfit || 0);
      setTotalLoss(response.data.totalLoss || 0);
      setError("");
    } catch (error) {
      console.error("Error fetching settlements:", error);
      setError("Failed to fetch settlement data.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    // Reset history when applying new filters
    setHistory([]);
    FetchUserData();
  };

  const handleAllSettlements = async ()=>{

    const auth= localStorage.getItem('admin');

    try{

      const response= await axios.get(base_url + "/api/admin/webapi/handleAllSettlemet",
        {
          headers : {
            "Content-Type" : "application/json",
            Authorization : `${auth}`
          }
        }
      )

    //   console.log("Response is ")
      //   

    }catch(err){
      console.log('err',err);
    }
  
  
   } 

  useEffect(() => {
    handleAllSettlements();
    FetchUserData();
  }, []);

  useEffect(() => {
        const handleResize = () => {
          const mobile = window.innerWidth < 768;
          setIsMobile(mobile);
          
          // On desktop, sidebar should always be "open"
          if (!mobile) {
            setIsSidebarOpen(true);
          }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchPhone(value);

    const filtered = settlements.filter((item) =>
      item.phone?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSettlements(filtered);
  };

  const handlePhoneClick = async (phone, code) => {
    try {
      setLoading(true);
      
      // Save current state to history before changing
      setHistory(prevHistory => [...prevHistory, {
        phone: searchPhone,
        code: history.length > 0 ? history[history.length - 1].code : null,
        data: settlements,
        filtered: filteredSettlements,
        profit: totalProfit,
        loss: totalLoss
      }]);
      
      setSearchPhone(phone);
  
      const auth = localStorage.getItem("admin");
  
      const response = await axios.get(`${base_url}/api/admin/getMySettleHistory`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`
        },
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
          code: code
        }
      });
  
      const data = response.data.data || [];
      setSettlements(data);
      setFilteredSettlements(data);
      setTotalProfit(response.data.totalProfit || 0);
      setTotalLoss(response.data.totalLoss || 0);
      setError("");
    } catch (error) {
      console.error("Error filtering by code:", error);
      setError("Failed to filter by code.");
    } finally {
      setLoading(false);
    }
  };
  
  const handleGoBack = () => {
    if (history.length > 0) {
      // Get the last item from history
      const lastItem = history[history.length - 1];
      
      // Restore previous state
      setSearchPhone(lastItem.phone);
      setSettlements(lastItem.data);
      setFilteredSettlements(lastItem.filtered);
      setTotalProfit(lastItem.profit);
      setTotalLoss(lastItem.loss);
      
      // Remove the last item from history
      setHistory(prevHistory => prevHistory.slice(0, -1));
    } else {
      // If no history, just reset to initial state
      setSearchPhone("");
      FetchUserData();
    }
  };

  const handleGetAllUserBets = async (phone) => {
    const auth = localStorage.getItem("admin");
  
    try {
      const response = await axios.post(
        `${base_url}/api/admin/webapi/GetAllUsersBet`,
        { phone },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      const responseCasino = await axios.post(
        `${base_url}/api/admin/webapi/GetCasinoUsersBet`,
        { phone },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

    //   console.log("Bet histyor is ", response);
    //   console.log("Resonise cabsini ", responseCasino)

  
    
      const { success, betsData } = response.data;
      const { betsDataCasino } = responseCasino.data
  
      if (success) {
        setUserCasinoBetData(betsDataCasino);
        setUserBetData(betsData);
        setSelectedPhone(phone);
        setBetModalVisible(true);
      } else {
        toast.error("Failed to fetch bet history");
      }
    } catch (err) {
      toast.error("Server error fetching history");
    }
  };
  
  
  
  

  const handleAdminSettlemet = async (phone, code, invite, role) => {
    const auth = localStorage.getItem("admin");
  
    try {
      const response = await axios.post(
        `${base_url}/api/admin/webapi/handleAdminSettlement`,
        { phone, code, invite, role },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
  
    //   console.log("Settlement response:", response.data);
      const { success, message } = response?.data;
    //   console.log("data is " , success , message)
      if (success) {
        toast.success(message || "Settlement completed successfully");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(message || "Settlement failed");
      }

      // if (response.data.success) {
      //   toast.success(response.data.message);
      //   setTimeout(() => {
      //     window.location.reload();
      //   }, 1000); // Optional delay
      // }
      

    //   console.log("Settlement response:", response.data);
    } catch (err) {
      // console.error("Settlement error:", err);
      toast.error("Something went wrong while settling.");
    }
  };
  

  const resetToMain = () => {
    // Clear history and reset to initial state
    setHistory([]);
    setSearchPhone("");
    FetchUserData();
  };

  const netProfit = totalProfit - totalLoss;

  const downloadPDF = () => {
    const doc = new jsPDF();
    const tableColumn = ["S No.", "Phone", "Role", "Profit", "Loss", "Date"];
    const tableRows = [];

    filteredSettlements.forEach((item, index) => {
      const rowData = [
        index + 1,
        item.phone,
        item.role,
        parseFloat(item.profit || 0).toFixed(2),
        parseFloat(item.loss || 0).toFixed(2),
        item.today?.split("T")[0]
      ];
      tableRows.push(rowData);
    });

    doc.text("Settlement History Report", 14, 10);

    autoTable(doc, {
      startY: 20,
      head: [tableColumn],
      body: tableRows
    });

    const summaryY = doc.lastAutoTable.finalY + 10;

    doc.text(`Total Profit: ${(totalProfit || 0).toFixed(2)}`, 14, summaryY);
    doc.text(`Total Loss: ${(totalLoss || 0).toFixed(2)}`, 14, summaryY + 10);
    doc.text(`Net:  ${(totalProfit - totalLoss).toFixed(2)}`, 14, summaryY + 20);
    doc.text(`Date Filter: ${fromDate || "N/A"} to ${toDate || "N/A"}`, 14, summaryY + 30);
    if (searchPhone) {
      doc.text(`Search Filter (Phone): ${searchPhone}`, 14, summaryY + 40);
    }

    doc.save("settlement_history.pdf");
  };

  // Create breadcrumb trail based on history
  const renderBreadcrumbs = () => {
    if (history.length === 0 && !searchPhone) return null;
    
    return (
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="##" onClick={(e) => {
              e.preventDefault();
              resetToMain();
            }}>Main</a>
          </li>
          
          {history.map((item, index) => (
            <li key={index} className="breadcrumb-item">
              <a href="##" onClick={(e) => {
                e.preventDefault();
                // Go back to this specific point in history
                const newHistory = history.slice(0, index);
                setHistory(newHistory);
                setSearchPhone(item.phone);
                setSettlements(item.data);
                setFilteredSettlements(item.filtered);
                setTotalProfit(item.profit);
                setTotalLoss(item.loss);
              }}>
                {item.phone || "Previous"}
              </a>
            </li>
          ))}
          
          {searchPhone && (
            <li className="breadcrumb-item active" aria-current="page">
              {searchPhone}
            </li>
          )}
        </ol>
      </nav>
    );
  };

  return (
    <div className="wrapper">
  
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
      {/* <section className="content-header">
  <div className="container-fluid">
    <div className="row mb-3">
      <div className="col">
        <h1 className="bg-dark text-white py-3 px-4 rounded shadow-sm d-inline-block">
          Settlement
        </h1>
      </div>
    </div>
  </div>
</section> */}

<div className="container-fluid">
  <div className="row">
    <div className="col-12">
      {/* Header Card */}
      <div className="bg-gradient p-3 rounded shadow mb-4" style={{ background: 'linear-gradient(to right, #00c6ff, #0072ff)', color: 'black' }}>
        <h4 className="mb-0"><i className="fas fa-coins me-2"></i>Settlement Dashboard</h4>
      </div>

      {/* Filter Card */}
      <div className="bg-white p-4 rounded shadow-sm mb-4 border border-light-subtle">
        <div className="row gy-3 gx-4 align-items-end">
          <div className="col-sm-6 col-md-3">
            <label htmlFor="fromDate" className="form-label"><i className="fas fa-calendar-alt me-2 text-primary"></i>From Date</label>
            <input
              type="date"
              id="fromDate"
              className="form-control shadow-sm"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="col-sm-6 col-md-3">
            <label htmlFor="toDate" className="form-label"><i className="fas fa-calendar-alt me-2 text-danger"></i>To Date</label>
            <input
              type="date"
              id="toDate"
              className="form-control shadow-sm"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="col-sm-6 col-md-2">
            <button className="btn btn-success w-100 shadow-sm" onClick={handleFilter}>
              <i className="fas fa-filter me-2"></i>Filter
            </button>
          </div>

          <div className="col-sm-6 col-md-4">
            <label htmlFor="searchPhone" className="form-label"><i className="fas fa-search me-2 text-muted"></i>Search username</label>
            <input
              type="text"
              id="searchPhone"
              className="form-control shadow-sm"
              placeholder="Enter user name"
              value={searchPhone}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>

      {/* Summary Section */}
      <div className="d-flex flex-wrap gap-3 mb-4">
        <span className="badge bg-success p-3 fs-6">
          <i className="fas fa-chart-line me-2"></i>Total Profit: ₹{(totalProfit || 0).toFixed(2)}
        </span>
        <span className="badge bg-danger p-3 fs-6">
          <i className="fas fa-chart-area me-2"></i>Total Loss: ₹{(totalLoss || 0).toFixed(2)}
        </span>
        <span className={`badge p-3 fs-6 ${netProfit > 0 ? 'bg-success' : netProfit < 0 ? 'bg-danger' : 'bg-secondary'}`}>
          <i className="fas fa-balance-scale me-2"></i>
          {netProfit > 0
            ? `Overall_Profit (₹${netProfit.toFixed(2)})`
            : netProfit < 0
              ? `Overall_Loss (₹${Math.abs(netProfit).toFixed(2)})`
              : "Neutral (₹0.00)"}
        </span>

        <span className="badge bg-blue p-3 fs-6" style={{cursor : "pointer"}} onClick={()=>window.location.reload()}>
          Refresh
        </span>
      </div>

      {/* Action Buttons */}
      <div className="d-flex justify-content-end flex-wrap gap-2 mb-3">
        <button onClick={downloadPDF} className="btn btn-primary shadow-sm">
          <i className="fas fa-file-pdf me-2"></i>Download PDF
        </button>
        {searchPhone && (
          <button className="btn btn-warning shadow-sm" onClick={resetToMain}>
            <i className="fas fa-undo me-2"></i>Clear All Filters
          </button>
        )}
      </div>

      {/* Breadcrumbs */}
      {renderBreadcrumbs()}

      {history.length > 0 && (
        <button className="btn btn-outline-secondary mb-3 shadow-sm" onClick={handleGoBack}>
          <i className="fas fa-arrow-left me-2"></i> Back to {history[history.length - 1].phone || "Previous"}
        </button>
      )}

      {/* Settlement Table */}
      <div className="table-responsive shadow rounded">
        <table className="table table-bordered table-hover align-middle text-center">
          <thead className="table-dark">
            <tr>
              <th>S No.</th>
              <th>User Name</th>
              <th>Role</th>
              <th>Keep Amount</th>
              <th>Pass Amount</th>
              <th>Profit/Loss</th>
              <th>Details</th>
              <th>Settle</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="7">Loading...</td></tr>
            ) : error ? (
              <tr><td colSpan="7" className="text-danger">{error}</td></tr>
            ) : filteredSettlements.length > 0 ? (
              filteredSettlements.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.phone}</td>
                  <td><span className="badge bg-info">{item.role}</span></td>
                  <td className="text-success">₹{parseFloat(item.profit || 0).toFixed(2)}</td>
                  <td className="text-danger">₹{parseFloat(item.loss || 0).toFixed(2)}</td>
                  <td className={
    parseFloat(item.profit || 0) - parseFloat(item.loss || 0) >= 0
      ? "text-success"
      : "text-danger"
  }>
    ₹{(parseFloat(item.profit || 0) - parseFloat(item.loss || 0)).toFixed(2)}
  </td>
                  <td>
                    {item.role !== 'user' ? (
                      <button className="btn btn-sm btn-info" onClick={() => handlePhoneClick(item.phone, item.code)}>
                        View Details
                      </button>
                    ) : (
                      <button className="btn btn-sm btn-info" onClick={() => handleGetAllUserBets(item.phone)}>
                        Bet History
                      </button>
                    )}
                  </td>
                  <td>
                    {item.role !== 'user' && (
                      <button className="btn btn-sm btn-danger" onClick={() => handleAdminSettlemet(item.phone, item.code, item.invite, item.role)}>
                        Settle
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="7">No settlements found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    <BetHistoryModal
  show={betModalVisible}
  onClose={() => setBetModalVisible(false)}
  userPhone={selectedPhone}
  historyData={userBetData}
  casinoHistoryData = {userCainoBetData}
/>

  </div>
</div>



      </div>
    </div>
  );
};

export default Settlement;